import Nodata from '@/ui/errorSigns/noData/Nodata';
import EsgTopicNews from './components/esgTopicNews/EsgTopicNews';
import TopNews from './components/topNews/TopNews';
import { SmallCardWrapper } from './MainNewsStyles';
import NewsCardSmall from '@/ui/card/newsCards/image/newsCardSmall/NewsCardSmall';
import { useTranslation } from 'react-i18next';

interface MainNewsProps {
  mainNews?: any[];
  esgTopicNews?: any[];
  navigateToESG?: () => void;
}

const MainNews = ({ mainNews, esgTopicNews, navigateToESG }: MainNewsProps) => {
  const [t] = useTranslation('noData');
  return (
    <div className="space-y-12">
      {mainNews.length > 0 ? (
        <div>
          <TopNews articles={mainNews} />
          <SmallCardWrapper>
            {mainNews.slice(10).map((article, i) => (
              <NewsCardSmall key={i} article={article} />
            ))}
          </SmallCardWrapper>
        </div>
      ) : (
        <Nodata desc={t('No ESG news.')} />
      )}
      <div>
        <EsgTopicNews topics={esgTopicNews} navigateToESG={navigateToESG} />
      </div>
    </div>
  );
};

export default MainNews;
